import {_libs} from "../../../utils/_libs.js";

/**
 * Promotion (Why Busland) — vertical carousel of key points. It centres on load,
 * loops seamlessly and auto-scrolls; the centred slide is highlighted (black)
 * next to the fixed Busland mark.
 *
 * Wired eagerly (not via the lazy initSection) so it's already centred before the
 * user scrolls to it — otherwise the un-initialised list shows stacked at the top.
 */
export const promotion = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.promotion:not(.js-promotion)').forEach((section) => {
            section.classList.add('js-promotion');
            init(section);
        });
        resolve();
    });
};

const DELAY = 2200;
const MIN_SLIDES = 16;

const init = (section) => {
    const sliderEl = section.querySelector('.promotion__slider');
    if (!sliderEl) return;

    const wrapper = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const originals = [...wrapper.querySelectorAll('.promotion__slide')];
    if (originals.length <= 1) return;

    // Swiper's centred loop needs comfortably more slides than fit on screen, or it
    // silently leaves gaps (empty space) at the ends. Repeat the set — the phrases
    // loop endlessly anyway, and the visible window never spans a full set, so no
    // duplicate is ever visible at once.
    while (wrapper.querySelectorAll('.promotion__slide').length < MIN_SLIDES) {
        originals.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
    }

    const swiper = _libs._swiper(sliderEl, {
        direction: 'vertical',
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 32,
        loop: true,
        speed: 600,
        grabCursor: true,
        breakpoints: {
            1025: {spaceBetween: 44},
        },
    });

    // Auto-advance (Swiper's Autoplay module isn't bundled — drive it ourselves),
    // only while the section is on screen and the tab is visible.
    let isVisible = false;
    let timer = null;
    const stop = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    };
    const start = () => {
        stop();
        if (isVisible && !document.hidden) {
            timer = setInterval(() => swiper.slideNext(), DELAY);
        }
    };

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', start);

    new IntersectionObserver((entries) => {
        entries.forEach((e) => {
            isVisible = e.isIntersecting;
            isVisible ? start() : stop();
        });
    }, {threshold: 0}).observe(section);
};
